var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 6.71875V4.53125H6.71875L10 1.25L13.2812 4.53125H11.0938V6.71875H8.90625Z",
    fill: "#222627"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 13.2812V15.4688H6.71875L10 18.75L13.2812 15.4688H11.0938V13.2812H8.90625Z",
    fill: "#222627"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2813 11.0937L15.4688 11.0937L15.4688 13.2812L18.75 10L15.4688 6.71875L15.4688 8.90625L13.2813 8.90625L13.2813 11.0937Z",
    fill: "#222627"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71875 8.90625L4.53125 8.90625L4.53125 6.71875L1.25 10L4.53125 13.2813L4.53125 11.0938L6.71875 11.0938L6.71875 8.90625Z",
    fill: "#222627"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.4375,
    y: 8.4375,
    width: 3.125,
    height: 3.125,
    stroke: "#222627",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove20);
export default __webpack_public_path__ + "static/media/move_20.0f7f34321e6f2a46f6fe29b23ca9ec5e.svg";
export { ForwardRef as ReactComponent };